const Card = ({
  style, children, className, id, borderRadius = 'rounded-[16px]', bgColor = 'bg-white dark:bg-grey-800/60', tabIndex, onKeyDown, ...props
}) => (
  <div {...props} id={id} tabIndex={tabIndex} onKeyDown={onKeyDown} style={style} key={props?.key} className={`border-focused border-grey-200 dark:border-grey-800 ${borderRadius} ${bgColor} ${className}`}>
    {children}
  </div>
);
export default Card;
